import { FC } from 'react';
import { Card, Text } from '@mofid-securities/uikit';
import { useAPI } from '@/services/index';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';
import { DescriptionSkeleton } from './Description.skeleton';

export const Description: FC = () => {
  const fundCode = useGetFundCodeFromQuery();

  const { data, isLoading } = useAPI(['fund', 'getFundDetail'], {
    input: {
      code: fundCode,
    },
  });

  if (isLoading) {
    return <DescriptionSkeleton />;
  }

  return data?.description ? (
    <Card
      className="border-1 border border-gray-solid-primary-enabled"
      padding={16}
      radius="md"
    >
      <Text
        className="mb-2 text-gray-filled-primary-enabled"
        component="h2"
        size="sm"
        weight="demibold"
      >
        صندوق {data.title} چیست؟
      </Text>
      <Text
        className="whitespace-pre-wrap font-sans text-gray-filled-secondary-enabled"
        component="pre"
        size="xs"
        weight="medium"
      >
        {data.description}
      </Text>
    </Card>
  ) : null;
};
